export default "__VITE_ASSET__Caz90GuN__"